/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pwa_Install_TitleInputs */

const cs_pwa_install_title = /** @type {(inputs: Pwa_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nainstalovat Cerebrio`)
};

const en_pwa_install_title = /** @type {(inputs: Pwa_Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Install Cerebrio`)
};

/**
* | output |
* | --- |
* | "Install Cerebrio" |
*
* @param {Pwa_Install_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pwa_install_title = /** @type {((inputs?: Pwa_Install_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pwa_Install_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pwa_install_title(inputs)
	return cs_pwa_install_title(inputs)
});